import { isNil } from 'lodash'
import {
  generateDefaultHeatmapHighLowColors,
  mapControlsStore,
} from 'stores/mapControlsStore/mapControlsStore'
import { sortNumber } from 'utils/sortNumber'

export const setHeatmapExtremesFromArrayOfValues = ({
  heatmapColoring = generateDefaultHeatmapHighLowColors(),
  isStale,
  values,
}: {
  heatmapColoring?: ReturnType<(typeof mapControlsStore)['getState']>['heatmapColoring']
  isStale: () => boolean
  values: (number | null)[]
}) => {
  if (isStale()) return

  const allValuesCleanedAndSorted = values.filter((v) => !isNil(v)).sort(sortNumber) as number[]

  if (allValuesCleanedAndSorted.length) {
    mapControlsStore.setState((s) => ({
      ...s,
      heatmapColoring,
      heatmapExtremes: s.manualExtremes
        ? s.heatmapExtremes
        : {
            min: allValuesCleanedAndSorted[0],
            max: allValuesCleanedAndSorted[allValuesCleanedAndSorted.length - 1],
          },
    }))
  } else {
    mapControlsStore.setState((s) => ({ ...s, heatmapColoring }))
  }
}
